import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { loginWithSwitchExchangeToken } from './AppSwitchSaga';
import { componentKey, setLoadingState } from './AppSwitchSlice';
import Loadable from '../../components/loadable/Loadable';
import { APP_SWITCH_STATES, APP_SWITCH_STATES_MESSAGE_MAP, APP_SWITCH_TOKEN } from './constants';
import { useEffect } from 'react';

export default function AppSwitch({ children }) {

    const { appSwitchLoaderState, redirectUrl } = useSelector(state => state[componentKey]);
    
	const [queryParams, setQueryParams] = useSearchParams();
	const dispatch = useDispatch();


	useEffect(() => {
		if (queryParams.has(APP_SWITCH_TOKEN)) {
			const switchToken = queryParams.get(APP_SWITCH_TOKEN);
			dispatch(loginWithSwitchExchangeToken({
				data: {
					[APP_SWITCH_TOKEN]: switchToken
				}
			}))
			queryParams.delete(APP_SWITCH_TOKEN)
			setQueryParams(queryParams);
		} 
        else {
            dispatch(setLoadingState( {state: APP_SWITCH_STATES.APP_SWITCH_READY} ))
        }
	}, [])

	useEffect(() => {
		if(redirectUrl) {
			window.location.href = redirectUrl;
		}
	}, [redirectUrl])

  return <Loadable currentState={appSwitchLoaderState.state} loadingStates={[APP_SWITCH_STATES.APP_SWITCH_LOADING]} messageMap={APP_SWITCH_STATES_MESSAGE_MAP} isNewLoadable={true}>
      
      { children }
    </Loadable>
}
